import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LINKS = [
  { id: "geschichte", label: "Unsere Geschichte" },
  { id: "zeitplan", label: "Zeitplan" },
  { id: "location", label: "Location" },
  { id: "galerie", label: "Fotogalerie" },
  { id: "rsvp", label: "RSVP" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-md bg-white/75 border-b border-sage-200 shadow-sm"
          : "bg-transparent"
      }`}
    >
      <div className="container mx-auto px-6 md:px-12 flex items-center justify-between h-16 md:h-20">
        <button
          data-testid="navbar-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          className={`font-script text-2xl md:text-3xl transition-colors ${
            scrolled ? "text-sage-700" : "text-white"
          }`}
        >
          Nico &amp; Nicole
        </button>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className={`text-sm tracking-wide transition-colors hover:text-sage-500 ${
                scrolled ? "text-sage-800" : "text-white/90"
              }`}
            >
              {l.label}
            </button>
          ))}
        </nav>

        <button
          data-testid="navbar-toggle"
          onClick={() => setOpen(!open)}
          className={`md:hidden p-2 ${scrolled ? "text-sage-800" : "text-white"}`}
          aria-label="Menü"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="navbar-mobile-menu"
          className="md:hidden backdrop-blur-md bg-white/90 border-t border-sage-200"
        >
          <div className="container mx-auto px-6 py-4 flex flex-col gap-4">
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`nav-mobile-${l.id}`}
                onClick={() => go(l.id)}
                className="text-left text-sage-800 text-base py-2 border-b border-sage-100 last:border-0"
              >
                {l.label}
              </button>
            ))}
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
